/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('PositionPermissionManagerCtrl', ["$rootScope", '$scope', '$http', 'NetworkService', 'MainService', 'IntentService', function ($rootScope, $scope, $http, NetworkService, MainService, IntentService) {

        $scope.mitarbeiter = []
        $scope.groupsInRead = []



        $rootScope.$on("saveGroupMembers", function (event, position_id) {

            var groups = $scope.groupsInRead
            var position_id = position_id;
            var event_id = MainService.getEventData().event_id;
            NetworkService.updatePermissionsForPosition(groups, position_id, event_id, function(data){
            })

        })



        $scope.updateInGroup = function (event, data)
        {
          console.log("UPDATING IN GROUP")
          console.log(data)
            $scope.groupsInRead = data
        }

        $rootScope.$on("setGroupMembers", $scope.updateInGroup)

        NetworkService.getGroups(function (data)
        {
            var groups = data.data;
            $scope.groups = groups
        })

        $scope.changeStateInRead = function (Gruppenname)
        {
            $scope.groupsInRead.forEach(function (el) {
                if (el.Gruppenname == Gruppenname)
                {
                    if (el.active == true)
                    {
                        el.active = false;
                    } else
                    {
                        el.active = true
                    }

                }
            })
        }



        $scope.moveToPersons = function ()
        {
            var newMitarbeiterInGroup = []
            $scope.groupsInRead.forEach(function (el) {
                if (el.active)
                {

                } else
                {
                    var newEl = {}
                    newEl.descr = el.descr
                    newEl.name = el.name
                    newEl.Gruppenname = el.Gruppenname
                    newMitarbeiterInGroup.push(newEl)
                }
            })

            $scope.groupsInRead = newMitarbeiterInGroup;
            console.log($scope.groupsInRead)
        }

        $scope.changeState = function (Gruppenname)
        {
            $scope.groups.forEach(function (el) {
                if (el.Gruppenname == Gruppenname)
                {
                    if (el.active == true)
                    {
                        el.active = false;
                    } else
                    {
                        el.active = true
                    }
                }
            })
        }

        $scope.arrayContained = function (a1, el)
        {
            ret = false
            a1.forEach(function (ela) {
                if (ela.Gruppenname == el.Gruppenname)
                {
                    ret = true
                }
            })

            return ret;
        }
        $scope.moveToRead = function ()
        {
            console.log("move to read")
            $scope.groups.forEach(function (el) {
                if (el.active)
                {
                    el.active = false;
                    var newEl = {}
                    newEl.Beschreibung = el.Beschreibung
                    newEl.Gruppenname = el.Gruppenname
                    newEl.Gruppenname = el.Gruppenname
                    if (!$scope.arrayContained($scope.groupsInRead, el))
                    {
                        $scope.groupsInRead.push(newEl)
                    }

                }
            })
        }




        $scope.moveBackFromRead = function ()
        {
            var newMitarbeiterInGroup = []
            $scope.groupsInRead.forEach(function (el) {
                if (el.active)
                {

                } else
                {
                    var newEl = {}
                    newEl.Beschreibung = el.Beschreibung
                    newEl.Gruppenname = el.Gruppenname
                    newEl.Gruppenname = el.Gruppenname
                    newMitarbeiterInGroup.push(newEl)
                }
            })
            $scope.groupsInRead = newMitarbeiterInGroup;
            console.log($scope.groupsInRead)
        }

    }])
